import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromUserManagement from './user-management.reducer';

export const selectUserManagementState = createFeatureSelector<fromUserManagement.State>(fromUserManagement.userManagementFeatureKey);

export const showSelectedUsers = createSelector(selectUserManagementState, fromUserManagement.getShowSelectedUsers);

export const selectedUsers = createSelector(selectUserManagementState, fromUserManagement.getSelectedUsers);

export const tableData = createSelector(selectUserManagementState, showSelectedUsers, (state, showSelectedUsers) => {
    return showSelectedUsers ? state.selectedUsers : state.loadedUsers;
});
